import { MapMouseEvent } from 'maplibre-gl';
import { DrawingObjectGeometry } from '../types';

export abstract class FeDrawMode {
    onMouseMove(e: MapMouseEvent) {}
    onMouseDown(e: MapMouseEvent) {}
    onMouseUp(e: MapMouseEvent) {}
    onClick(e: MapMouseEvent) {}
    cancel() {}
    onKeyDown(e: KeyboardEvent) {}
    draw() {}
    edit(object: DrawingObjectGeometry) {}
    getEdited(): DrawingObjectGeometry {
        throw new Error('Not implemented.');
    }
    finalize() {}
}
